import {UnitCheckComponent} from "./checks/UnitCheck";
import {Fragment, useEffect, useState} from "react";
import {UnitNoCheckComponent} from "./checks/UnitNoCheck";
import {
    Autocomplete,
    Box,
    Button, Checkbox,
    Divider,
    FormControlLabel,
    FormGroup,
    Grid,
    Paper,
    TextField,
    Typography
} from "@mui/material";
import {requestServer} from "../Global/FunctionToConnection";
import {Loading} from "../Global/LoadingComponent";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import {DEBUG, URL_SERVER, URL_TEST} from "../Global/constant";

const VALUE_DATE = {
    inicio: dayjs(new Date()).date(1),
    fin: dayjs(new Date()),
}

export function ShowUnitCheckComponent(){

    const [ showCheck, setShowCheck ] = useState(true);

    const [ showNoCheck, setShowNoCheck ] = useState(false);

    const [ dataCheck, setDataCheck ] = useState([]);

    const [ dataNoCheck, setDataNoCheck ] = useState([]);

    const [ refreshCheck, setRefreshCheck ] = useState(false);

    const [ dataUnits, setDataUnits ] = useState([]);

    const [ unitSearch, setUnitSearch ] = useState(null);

    const [dataByUnits, setDataByUnits ] = useState([]);

    const [ rangeDate, setRangeDate ] = useState(false);

    const [ date, setDate ] = useState(VALUE_DATE)

    useEffect(() => {
        const getUnitCheck = async () => {
            Loading({open:true});
            let url = DEBUG? URL_TEST.unidad_checks : URL_SERVER.unidad_checks;

            try {
                let response_all_units = await requestServer(url, null, DEBUG );
                let response_units = await requestServer("pre-orden-reporte" );
                setDataCheck(response_all_units.check);
                setDataNoCheck(response_all_units.no_check);
                setDataUnits(response_units.unidad);
                setUnitSearch(null);
                Loading({open:false});
            } catch (e) {
                console.error(e);
                Loading({open:false});
            }
        }
        getUnitCheck();
    }, [refreshCheck]);


    const handlingShowCheck = () => {
        Loading({open:true});
        setShowCheck(true);
        setShowNoCheck(false);
        Loading({open:false});
    }

    const handlingShowNoCheck = () => {
        Loading({open:true});
        setShowCheck(false);
        setShowNoCheck(true);
        Loading({open:false});
    }

    async function searchUnitService(unitData) {
        Loading({open:true});
        let params = {
            unit_id: unitData
        }
        let response_units = await requestServer("todas-unidades-revision", params);

        setDataByUnits(response_units.check);
        setUnitSearch(unitData);
        Loading({open:false});
    }

    const handlingDateUpdate = (typeDate) => (dataEvent) => {
        setDate((beforeDate)=>{
            return{
                ...beforeDate,
                [typeDate]: dataEvent
            }
        })
    }


    return(
        <Paper elevation={12} style={{marginTop: "2vh"}}>

            <Grid container spacing={1}>

                <Grid item xs={3} >
                    <Button fullWidth variant="contained" color={showCheck? "success":"secondary"}
                            onClick={handlingShowCheck}
                    >Unidades revisadas</Button>
                </Grid>

                <Grid item xs={3} >
                    <Button fullWidth variant="contained" color={showNoCheck? "success":"secondary"}
                            onClick={handlingShowNoCheck}
                    >Unidades no revisadas</Button>
                </Grid>

                <Grid item xs={3} >
                    <Button fullWidth variant="contained" color="info"
                            onClick={()=>setRefreshCheck(!refreshCheck)}
                    >Recargar tabla</Button>
                </Grid>

                <Grid item xs={3} >
                    {
                        !!unitSearch?
                            <Button fullWidth variant="contained" color="warning"
                            onClick={()=> {
                                setUnitSearch(null);
                                setDataByUnits([]);
                            }}
                            >Limpiar busqueda</Button>:
                            <Autocomplete
                                value={unitSearch}
                                readOnly={!!unitSearch }
                                onChange={(event, things)=> searchUnitService(things)}
                                renderInput={(params) => <TextField {...params} label="Unidad" />}
                                options={dataUnits}/>
                    }
                </Grid>

                {
                    rangeDate &&
                        <Fragment>

                            <Grid item xs={3}>
                                <FormGroup>
                                    <FormControlLabel control={ <Checkbox checked={rangeDate} onChange={()=>setRangeDate(!rangeDate)} /> } label={"Rango de fechas"} />
                                </FormGroup>
                            </Grid>

                            {
                                rangeDate &&
                                    <Fragment>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Grid item xs={3}>
                                                <DatePicker
                                                    label="Fecha inicio"
                                                    value={date.inicio}
                                                    maxDate={dayjs(new Date())}
                                                    format="DD/MM/YYYY"
                                                    onChange={handlingDateUpdate("inicio")}
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                               <DatePicker
                                                    label="Fecha Fin"
                                                    value={date.fin}
                                                    maxDate={dayjs(new Date())}
                                                    format="DD/MM/YYYY"
                                                    onChange={handlingDateUpdate("fin")}
                                                />
                                            </Grid>
                                        </LocalizationProvider>
                                    </Fragment>
                            }
                        </Fragment>
                }

            </Grid>

            <Box style={{width: "100%", height: "2vh", marginTop: "2vh"}}>
                <Divider/>
            </Box>


            {
                showCheck?
                    <Fragment>
                        {
                            !!dataByUnits?
                                <UnitCheckComponent
                                    dataCheck={!!unitSearch ? dataByUnits: dataCheck}
                                />:<Typography>La unidad no cuenta con registro, contacta al supervisor en turno.</Typography>
                        }
                    </Fragment>:null

            }
            {
                showNoCheck &&
                <UnitNoCheckComponent
                    dataNoCheck={dataNoCheck}
                />
            }
        </Paper>
    );
}